// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_3PZMA","text":"index_text_2Y80l","textHidden":"index_textHidden_12zqh","contentBox":"index_contentBox_1Dikn","boxTitle":"index_boxTitle_2nzvB"};